<template>
    <CCard>
        <CCardBody>
            <h5 class="text-primary">Speciality</h5>
            <GPie v-if="specialityChartData.length" :data="specialityChartData" :keys="keys"/>
        </CCardBody>
    </CCard>
</template>
<script>
import GPie from "@/components/reusable/Charts/GPie.vue";
import clinicalData from "@/containers/ClinicalPlacementDashboard/clinicalData.json";
export default {
    name: "SpecialityChart",
    components: {
        GPie,
    },
    computed: {
        specialityChartData() {
            const count = clinicalData.reduce((acc, item) => {
                if (!acc[item["Specialty"]] ) {
                    acc[item["Specialty"]] = 0;
                }
                acc[item["Specialty"]]++;
                return acc;
            }, {});
            const counts = Object.entries(count).map(([speciality, count], index) => ({
                name: speciality,
                value: count,
                backgroundColor: "#b1a5d6",
                borderColor: "#b1a5d6",
            }));
            return counts;
        },
        keys() {
            return ["Speciality", "Count"];
        },
    }
};
</script>